import { useDocumentDetails } from 'hooks/useDocumentDetails';
import type { Document } from 'types';
import type { LandUseRedesignation } from 'types/Documents';

export const useLandUseRedesignation = (id: string | null) =>
  useDocumentDetails<Document<LandUseRedesignation> | null>(id);
